import React from 'react';
import './myfooter.css'; // Adjust the path as necessary


export default function MyFooter() {
  return (
 <footer className="footer">
<p className='text-white'><span className='opacity-8 fw-300'> © 2025  JP International School is Powered by   </span> 
    <a href="https://www.growthxanalytics.com/" target="_blank">  GrowthX Analytics Private Limited </a> </p>
 </footer>
  );
}
